import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';

const ID = '61';
const IABid = [25];

export const createPixel = (): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = 'https://ups.analytics.yahoo.com/ups/58290/sync?redir=true';

  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    const iframe = createPixel();

    fastdom.mutate(function userSyncVerizonAddElement() {
      document.body.appendChild(iframe);
    });
  }),
);
